import GrauInstrucaoList from './list';

export default function GrauInstrucaoPage() {
  return <GrauInstrucaoList />;
}
